import React from 'react';
import { FaTimes } from 'react-icons/fa'; // Import the icon for closing

const Sidebar = ({ isOpen, toggleSidebar, rows, onSelectHCW }) => {
    if (!isOpen) return null;

    return (
        <div className="sidebar">
            <FaTimes className="close-icon" onClick={toggleSidebar} />{' '}
            {/* Close icon */}
            <h3>Healthcare Workers</h3>
            {/* Check if rows is an array before mapping */}
            {Array.isArray(rows) && rows.length > 0 ? (
                rows.map((hcw) => (
                    <div
                        key={hcw.id}
                        className="sidebar-item"
                        onClick={() => onSelectHCW(hcw)} // Select healthcare worker
                    >
                        {`${hcw.id}: ${hcw.first_name} ${hcw.last_name}`}
                    </div>
                ))
            ) : (
                <div>No Healthcare Workers available</div>
            )}
        </div>
    );
};

export default Sidebar;
